document.addEventListener('DOMContentLoaded', () => {
  initializeJBDeliveryEstimators();
});

document.addEventListener('shopify:section:load', () => {
  initializeJBDeliveryEstimators();
});

function initializeJBDeliveryEstimators() {
  const estimators = document.querySelectorAll(
    '[data-jb-delivery-estimator]:not([data-jb-initialized])'
  );

  estimators.forEach((estimator) => {
    estimator.setAttribute('data-jb-initialized', 'true');

    const minimumDays = Number(estimator.dataset.minDays) || 7;
    const maximumDays = Number(estimator.dataset.maxDays) || 14;

    const deliveryRange = estimator.querySelector(
      '[data-jb-delivery-range]'
    );

    const countdown = estimator.querySelector(
      '[data-jb-delivery-countdown]'
    );

    const formatDeliveryDate = (date) => {
      return new Intl.DateTimeFormat('en-GB', {
        day: 'numeric',
        month: 'short'
      }).format(date);
    };

    const updateDeliveryRange = () => {
      const now = new Date();

      const earliestDate = new Date(now);
      earliestDate.setDate(now.getDate() + minimumDays);

      const latestDate = new Date(now);
      latestDate.setDate(now.getDate() + maximumDays);

      if (
        earliestDate.getMonth() === latestDate.getMonth() &&
        earliestDate.getFullYear() === latestDate.getFullYear()
      ) {
        const monthYear = new Intl.DateTimeFormat('en-GB', {
          month: 'short'
        }).format(latestDate);

        deliveryRange.textContent =
          `${earliestDate.getDate()}–${latestDate.getDate()} ${monthYear}`;
      } else {
        deliveryRange.textContent =
          `${formatDeliveryDate(earliestDate)}–${formatDeliveryDate(latestDate)}`;
      }
    };

    const updateCountdown = () => {
      const now = new Date();

      const midnight = new Date(now);
      midnight.setHours(23, 59, 59, 999);

      const difference = midnight.getTime() - now.getTime();

      if (difference <= 0) {
        updateDeliveryRange();
        return;
      }

      const hours = Math.floor(
        difference / (1000 * 60 * 60)
      );

      const minutes = Math.floor(
        (difference % (1000 * 60 * 60)) / (1000 * 60)
      );

      countdown.textContent =
        `${hours} Hours ${minutes} Minutes`;
    };

    updateDeliveryRange();
    updateCountdown();

    window.setInterval(updateCountdown, 1000);
  });
}


/* ==========================================
   Sticky Add to Cart
   Desktop + Mobile
========================================== */

function initializeJBStickyCart() {
  document
    .querySelectorAll(
      '[data-jb-mobile-sticky-cart]:not([data-jb-sticky-ready])'
    )
    .forEach((stickyCart) => {
      stickyCart.dataset.jbStickyReady = 'true';

      const productInfo = stickyCart.closest('product-info');

      if (!productInfo) {
        return;
      }

      const stickyButton = stickyCart.querySelector(
        '[data-jb-sticky-submit]'
      );

      const stickyPrice = stickyCart.querySelector(
        '[data-jb-sticky-price]'
      );

      let mainButtonVisible = true;

      let observedMainButton = null;

      let visibilityObserver = null;

      let syncFrame = null;


      /* ------------------------------------------
         Find original Shopify Add to Cart button
      ------------------------------------------ */

      const getMainButton = () => {
        return productInfo.querySelector(
          '.product-form__submit'
        );
      };


      /* ------------------------------------------
         Find current product / variant price
      ------------------------------------------ */

      const getMainPrice = () => {
        return (
          productInfo.querySelector(
            '[id^="price-"] .price-item--sale.price-item--last'
          ) ||
          productInfo.querySelector(
            '[id^="price-"] .price-item--regular'
          )
        );
      };


      /* ------------------------------------------
         Synchronize sticky cart
      ------------------------------------------ */

      const updateStickyContent = () => {
        const mainButton = getMainButton();

        const mainPrice = getMainPrice();


        /* Sync price */

        if (mainPrice && stickyPrice) {
          const latestPrice =
            mainPrice.textContent.trim();

          if (
            stickyPrice.textContent.trim() !== latestPrice
          ) {
            stickyPrice.textContent = latestPrice;
          }
        }


        /* Sync Add to Cart text + availability */

        if (mainButton && stickyButton) {
          const latestText =
            mainButton
              .querySelector('span')
              ?.textContent.trim() ||
            'Add to cart';

          if (
            stickyButton.textContent.trim() !== latestText
          ) {
            stickyButton.textContent = latestText;
          }

          stickyButton.disabled =
            mainButton.disabled ||
            mainButton.getAttribute(
              'aria-disabled'
            ) === 'true';
        }
      };


      /* ------------------------------------------
         Show sticky cart only after main ATC
         leaves viewport
      ------------------------------------------ */

      const updateVisibility = () => {
        const shouldShow =
          !mainButtonVisible &&
          window.scrollY > 200;

        stickyCart.classList.toggle(
          'is-visible',
          shouldShow
        );
      };


      /* ------------------------------------------
         Observe original Add to Cart
      ------------------------------------------ */

      const observeMainButton = () => {
        const currentMainButton =
          getMainButton();

        if (
          !currentMainButton ||
          currentMainButton === observedMainButton
        ) {
          return;
        }


        /* Stop observing previous button */

        if (
          visibilityObserver &&
          observedMainButton
        ) {
          visibilityObserver.unobserve(
            observedMainButton
          );
        }

        observedMainButton =
          currentMainButton;


        /* Create observer once */

        if (!visibilityObserver) {
          visibilityObserver =
            new IntersectionObserver(
              (entries) => {
                const entry = entries[0];

                mainButtonVisible =
                  entry.isIntersecting;

                updateVisibility();
              },
              {
                threshold: 0.1
              }
            );
        }

        visibilityObserver.observe(
          observedMainButton
        );
      };


      /* ------------------------------------------
         Batch DOM updates
      ------------------------------------------ */

      const scheduleSync = () => {
        if (syncFrame) {
          return;
        }

        syncFrame =
          window.requestAnimationFrame(() => {
            syncFrame = null;

            observeMainButton();

            updateStickyContent();

            updateVisibility();
          });
      };


      /* ------------------------------------------
         Sticky Add to Cart click
         Uses real Shopify button
      ------------------------------------------ */

      stickyButton?.addEventListener(
        'click',
        () => {
          const currentMainButton =
            getMainButton();

          if (
            currentMainButton &&
            !currentMainButton.disabled
          ) {
            currentMainButton.click();
          }
        }
      );


      /* ------------------------------------------
         Scroll visibility
      ------------------------------------------ */

      window.addEventListener(
        'scroll',
        updateVisibility,
        {
          passive: true
        }
      );


      /* ------------------------------------------
         Shopify variant updates often replace
         price/button HTML.

         MutationObserver keeps sticky cart synced
         without polling every 500ms.
      ------------------------------------------ */

      const contentObserver =
        new MutationObserver(
          scheduleSync
        );

      contentObserver.observe(
        productInfo,
        {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: [
            'disabled',
            'aria-disabled',
            'class'
          ]
        }
      );


      /* ------------------------------------------
         Cleanup
      ------------------------------------------ */

      window.addEventListener(
        'pagehide',
        () => {
          contentObserver.disconnect();

          visibilityObserver?.disconnect();

          if (syncFrame) {
            window.cancelAnimationFrame(
              syncFrame
            );
          }
        },
        {
          once: true
        }
      );


      /* ------------------------------------------
         Initial setup
      ------------------------------------------ */

      observeMainButton();

      updateStickyContent();

      updateVisibility();
    });
}


/* Initial page load */

document.addEventListener(
  'DOMContentLoaded',
  initializeJBStickyCart
);


/* Shopify Theme Editor */

document.addEventListener(
  'shopify:section:load',
  initializeJBStickyCart
);